<script>
  /**
   * Specify shape variant
   * @type {"1" | "2"}
   */
  export let variant = '1';

  /**
   * Specify top color
   * @type {"bg-1" | "bg-2" | "bg-3" | "bg-4" | "a1-b"}
   */
  export let top = 'bg-1';
  
  /**
   * Specify bottom color
   * @type {"bg-1" | "bg-2" | "bg-3" | "bg-4" | "bg-4" | "a1-b"}
   */
  export let bottom = 'bg-1';
</script>

{#if variant == "1"}
  <svg viewBox="0 0 1680 284">
    <rect class={top} width="1680" height="284"/>
    <path class={bottom} d="M1680 0C1680 0 1593.67 12.0409 1541 29.4998C1432.25 65.5446 1403.09 159.322 1291 183C1128.87 217.249 1050.87 47.3893 885.5 58C748.339 66.8007 692.346 203.897 556.5 183C467.154 169.256 435.554 108.765 351.5 75.5C220.952 23.8342 0 0 0 0V284H1680V0Z"/>
  </svg>
{:else if variant == "2"}
  <svg viewBox="0 0 1680 168">
    <rect class={top} width="1680" height="168"/>
    <path class={bottom} d="M1680 168H0S271.824 0 841.502 0C1411.18 0 1680 168 1680 168z">
  </svg>
{/if}


<style>
  svg {
    display: block;
    margin-bottom: -1px;
  }

  .bg-1 { fill: var(--bg-1); }
  .bg-2 { fill: var(--bg-2); }
  .bg-3 { fill: var(--bg-3); }
  .bg-4 { fill: var(--bg-4); }
  .bg-5 { fill: var(--bg-5); }
  .a1-b { fill: var(--a1-b); }
</style>